// src/components/DashboardHeader.jsx (senda qaysi nom bo'lsa o'shani almashtir)
import React, { useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.jpg";
import eng from "../assets/eng.png";
import uz from "../assets/uzb.png";
import ru from "../assets/rus.png";
import { FiUser, FiLogOut } from "react-icons/fi";
import { getCurrentUser, clearAuth, getToken } from "../utils/auth";

const LANGS = [
  { code: "ru", label: "Русский", flag: ru },
  { code: "uz", label: "O‘zbek", flag: uz },
  { code: "en", label: "English", flag: eng },
];

export default function DashboardHeader() {
  const navigate = useNavigate();
  const [navOpen, setNavOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [currentLang, setCurrentLang] = useState("uz");

  const current = LANGS.find((l) => l.code === currentLang) || LANGS[1];

  const user = getCurrentUser();
  const token = getToken();
  const isAuthenticated = !!token;

  const displayName = useMemo(() => {
    if (!user) return "Foydalanuvchi";
    if (user.name && user.name.trim().length > 0) return user.name;
    if (user.phone) return user.phone;
    return "Foydalanuvchi";
  }, [user]);

  const handleLogout = () => {
    clearAuth();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto flex items-center justify-between h-16 md:h-20 px-4 md:px-0">
        {/* LOGO */}
        <Link to="/" className="flex items-center gap-3">
          <img src={logo} alt="LiveQuiz" className="h-10 w-auto select-none" />
          <span className="text-2xl font-bold text-gray-900">LiveQuiz</span>
        </Link>

        {/* NAV LINKS */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium">
          <Link to="/dashboard" className="block font-medium">
            Umumiy ko‘rinish
          </Link>
          <Link to="/dashboard/create" className="block">
            Test yaratish
          </Link>
          <Link to="/dashboard/tests" className="block">
            Mening testlarim
          </Link>
          <Link to="/dashboard/profile" className="block">
            Profil
          </Link>
        </nav>

        {/* RIGHT SIDE */}
        <div className="hidden md:flex items-center gap-4 font-medium">
          {/* LANGUAGE DROPDOWN */}
          <div className="relative">
            <button
              onClick={() => {
                setLangOpen((v) => !v);
                setUserOpen(false);
              }}
              className="flex items-center gap-2 text-gray-700 hover:text-gray-900"
            >
              <img
                src={current.flag}
                alt={current.label}
                className="h-4 w-6 rounded-sm object-cover"
              />
              <span className="text-sm">{current.label}</span>
            </button>

            {langOpen && (
              <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 shadow-lg rounded-lg py-2 text-sm">
                {LANGS.map((lang) => (
                  <button
                    key={lang.code}
                    className={`flex items-center gap-2 px-3 py-2 w-full text-left hover:bg-gray-50 ${
                      lang.code === currentLang ? "bg-gray-100" : ""
                    }`}
                    onClick={() => {
                      setCurrentLang(lang.code);
                      setLangOpen(false);
                    }}
                  >
                    <img
                      src={lang.flag}
                      className="h-4 w-6 rounded-sm object-cover"
                      alt={lang.label}
                    />
                    {lang.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* USER DROPDOWN */}
          {isAuthenticated && user ? (
            <div className="relative">
              <button
                onClick={() => {
                  setUserOpen((v) => !v);
                  setLangOpen(false);
                }}
                className="flex items-center gap-2 text-gray-800 hover:text-gray-900"
              >
                <FiUser className="h-4 w-4" />
                <span className="text-sm">{displayName}</span>
              </button>

              {userOpen && (
                <div className="absolute right-0 mt-2 w-52 bg-white border border-gray-200 rounded-xl shadow-lg text-sm py-1">
                  <Link
                    to="/dashboard/profile"
                    className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50"
                    onClick={() => setUserOpen(false)}
                  >
                    <FiUser className="w-4 h-4 text-gray-500" />
                    <span>Profil</span>
                  </Link>

                  <button
                    type="button"
                    onClick={handleLogout}
                    className="flex items-center gap-2 px-3 py-2 w-full text-left hover:bg-gray-50 text-red-500"
                  >
                    <FiLogOut className="w-4 h-4" />
                    <span>Chiqish</span>
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="flex items-center gap-4">
              <Link className="text-gray-700 hover:text-gray-900" to="/login">
                Kirish
              </Link>
            </div>
          )}
        </div>

        {/* MOBILE TOGGLE ... (mob partingni xuddi shu displayName va handleLogout bilan qoldiraverasan) */}
      </div>
      {/* mobil menyu eski koding bilan qoladi, faqat userName o'rniga displayName ishlat */}
    </header>
  );
}
